import { useCallback, useContext, useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { SocketContext } from "../../../../context/socket";

const WebSocketTransformVideos = ({ streamIds, transformVideos, updateTransformVideo }) => {
  const { webhookSocket } = useContext(SocketContext);

  const handleProgressUpdate = useCallback(
    (payload) => {
      const progress = payload?.data?.percentage ?? 0;
      const requestId = payload?.data?.referenceClipRequestId;

      if (transformVideos.hasOwnProperty(requestId)) {
        const data = {
          progress,
          status: "PROCESSING",
        };

        updateTransformVideo({ requestId, data });
      }
    },
    [transformVideos, updateTransformVideo],
  );

  const handleComplete = useCallback(
    (payload) => {
      const requestId = payload?.requestId;

      if (transformVideos.hasOwnProperty(requestId)) {
        const data = {
          status: "COMPLETED",
          progress: 100,
        };

        updateTransformVideo({ requestId, data });
      }
    },
    [transformVideos, updateTransformVideo],
  );

  const handleFailed = useCallback(
    (payload) => {
      const requestId = payload?.requestId;

      if (transformVideos.hasOwnProperty(requestId)) {
        const data = {
          status: "FAILED",
        };

        updateTransformVideo({ requestId, data });
      }
    },
    [transformVideos, updateTransformVideo],
  );

  useEffect(() => {
    const idsToListen = streamIds || [];

    if (idsToListen.length === 0) return;

    const eventHandlerMappings = [];

    idsToListen.forEach((id) => {
      const progressEventName = `transformJob_export_${id}`;
      const completeEventName = `mediaConvertCut_${id}`;
      const failedEventName = `mediaConvertCutFailed_${id}`;

      webhookSocket.on(progressEventName, handleProgressUpdate);
      webhookSocket.on(completeEventName, handleComplete);
      webhookSocket.on(failedEventName, handleFailed);

      eventHandlerMappings.push(
        { event: progressEventName, handler: handleProgressUpdate },
        { event: completeEventName, handler: handleComplete },
        { event: failedEventName, handler: handleFailed },
      );
    });

    return () => {
      eventHandlerMappings.forEach(({ event, handler }) => {
        webhookSocket.off(event, handler);
      });
    };
  }, [webhookSocket, streamIds, handleProgressUpdate, handleComplete, handleFailed]);

  return null;
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(WebSocketTransformVideos);
